import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import fr from './locales/fr.json'
import nl from './locales/nl.json'

// Detect the browser/system language (e.g. "fr", "en-US")
const systemLang = navigator.language.split('-')[0] // normalize "en-US" → "en"

// List of supported languages
const supportedLangs = ['en', 'fr', 'nl'] as const

export type SupportedLang = (typeof supportedLangs)[number] | undefined

// If system language is supported, use it, otherwise default to English
const initialLang = (supportedLangs as readonly string[]).includes(systemLang) ? systemLang : 'en'

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    nl: { translation: nl },
  },
  lng: initialLang, // 👈 dynamic language
  fallbackLng: 'en', // 👈 fallback to English only
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

export default i18n
